var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Review",
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.609,
    height: 71.5,
    viewBox: "0 0 53.609 71.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M41,5.021H34.006V1.589A1.593,1.593,0,0,0,32.417,0H11.856a1.594,1.594,0,0,0-1.589,1.589V5.021H3.276a7.947,7.947,0,0,0-7.944,7.944v50.59A7.948,7.948,0,0,0,3.276,71.5H41a7.947,7.947,0,0,0,7.944-7.944V12.965A7.947,7.947,0,0,0,41,5.021ZM13.445,3.178H30.828V9.756H13.445ZM45.763,63.556A4.78,4.78,0,0,1,41,68.322H3.276A4.781,4.781,0,0,1-1.49,63.556V12.965A4.781,4.781,0,0,1,3.276,8.2h6.991v3.162a1.594,1.594,0,0,0,1.589,1.589h20.56a1.593,1.593,0,0,0,1.589-1.589V8.2H41a4.78,4.78,0,0,1,4.767,4.767Zm0,0",
    transform: "translate(4.668)",
    fill: "#009639"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M97.1,176a15.889,15.889,0,1,0,15.889,15.889A15.889,15.889,0,0,0,97.1,176Zm0,28.6a12.711,12.711,0,1,1,12.711-12.711A12.711,12.711,0,0,1,97.1,204.6Zm0,0",
    transform: "translate(-70.291 -153.628)",
    fill: "#009639"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M151.927,256.636l-8.373,8.008-4.29-4.29a1.584,1.584,0,0,0-2.24,2.24l5.387,5.386a1.561,1.561,0,0,0,1.128.461,1.54,1.54,0,0,0,1.1-.445l9.5-9.073a1.582,1.582,0,0,0,.047-2.24A1.617,1.617,0,0,0,151.927,256.636Zm0,0",
    transform: "translate(-118.607 -223.634)",
    fill: "#009639"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/Review.e7b2d65d3eff91fc1a1d5119db16da36.svg";
export { ForwardRef as ReactComponent };